/**
 * @Email : kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @jobTittle: Full Stack Developer
 *
 */

import React from 'react';
import HeadTittle from '../../../../../components/HeadTittle';
import routes from '../../../../../Routes/routes';
import { CommonContractorCreateUpdateApp } from '../../Functionality/ContractorCreateUpdateFlows/CommonContractorCreateUpdateApp';
import { ContractorCreateEmployeeApp } from '../../Functionality/EmployeeCreateUpdateFlows/ContractorCreateEmployeeApp';
import CopySecretModal from '../../../Company/Employees/Modal/CopySecretModal';
import ContractorEmployeeCreateWithDetails from './ContractorEmployeeCreateWithDetails';
import ContractorEmployeeCreateWithoutDetails from './ContractorEmployeeCreateWithoutDetails';

const ContractorCreateEmployee = () => {
    const props = CommonContractorCreateUpdateApp();

    const {
        t,
        navigate,
        permission,
        dispatch,
        isValidEmail,
        isValidPhoneNumber,
        isValidDob,
        setIsValidDob,
        isValidDocumentId,
        setIsValidDocumentId,
        userInfoStatusList,
        emptyFields,
        setEmptyFields,
        generatedPassword,
        setGeneratedPassword,
        secretModal,
        setSecretModal,
        secretKey,
        setSecretKey,
        passwordGenerator,
        photoPicker,
        setPhotoPicker,
        handleDateChange,
        handleEmailChange,
        handlePasswordChange,
        isValidPassword,
        setIsValidPassword,
        handlePhoneNumberChange,
        validateEmail,
        validatePhone,
        validatePassword,
        reset,
        extraData,
        extraDataEnabled,
        setExtraData,
        setExtraDataEnabled,
        headersList,
    } = props;

    const {
        user,
        setUser,
        FormHandler,
        steps,
        activeStep,
        setActiveStep,
        handleStepChange,
        handleClearAll,
        handleValidateSteps,
        handleChange,
        handleClearExtraData,
    } = ContractorCreateEmployeeApp({
        t,
        permission,
        dispatch,
        setEmptyFields,
        isValidEmail,
        isValidPhoneNumber,
        isValidDob,
        isValidPassword,
        setIsValidPassword,
        reset,
        photoPicker,
        setPhotoPicker,
        setSecretModal,
        setSecretKey,
        setGeneratedPassword,
        passwordGenerator,
        validateEmail,
        validatePhone,
        validatePassword,
        isValidDocumentId,
        extraData,
        extraDataEnabled,
        setExtraData,
        setExtraDataEnabled,
        headersList,
    });

    return (
        <>
            <HeadTittle link={routes.contractor.searchEmployee} name={t('create')} />

            {extraDataEnabled ? (
                <ContractorEmployeeCreateWithDetails
                    user={user}
                    setUser={setUser}
                    steps={steps}
                    activeStep={activeStep}
                    setActiveStep={setActiveStep}
                    handleStepChange={handleStepChange}
                    emptyFields={emptyFields}
                    isValidDocumentId={isValidDocumentId}
                    setIsValidDocumentId={setIsValidDocumentId}
                    isValidEmail={isValidEmail}
                    isValidPhoneNumber={isValidPhoneNumber}
                    isValidDob={isValidDob}
                    setIsValidDob={setIsValidDob}
                    handleEmailChange={handleEmailChange}
                    handlePasswordChange={handlePasswordChange}
                    handlePhoneNumberChange={handlePhoneNumberChange}
                    handleDateChange={handleDateChange}
                    userInfoStatusList={userInfoStatusList}
                    handleClearAll={handleClearAll}
                    handleValidateSteps={handleValidateSteps}
                    extraData={extraData}
                    setExtraData={setExtraData}
                    handleChange={handleChange}
                    handleClearExtraData={handleClearExtraData}
                    headersList={headersList}
                    photoPicker={photoPicker}
                    setPhotoPicker={setPhotoPicker}
                    FormHandler={FormHandler}
                    extraDataEnabled={extraDataEnabled}
                />
            ) : (
                <ContractorEmployeeCreateWithoutDetails
                    user={user}
                    setUser={setUser}
                    steps={steps}
                    activeStep={activeStep}
                    setActiveStep={setActiveStep}
                    handleStepChange={handleStepChange}
                    emptyFields={emptyFields}
                    isValidDocumentId={isValidDocumentId}
                    setIsValidDocumentId={setIsValidDocumentId}
                    isValidEmail={isValidEmail}
                    isValidPhoneNumber={isValidPhoneNumber}
                    isValidDob={isValidDob}
                    setIsValidDob={setIsValidDob}
                    handleEmailChange={handleEmailChange}
                    handlePasswordChange={handlePasswordChange}
                    handlePhoneNumberChange={handlePhoneNumberChange}
                    handleDateChange={handleDateChange}
                    userInfoStatusList={userInfoStatusList}
                    handleClearAll={handleClearAll}
                    handleValidateSteps={handleValidateSteps}
                    photoPicker={photoPicker}
                    setPhotoPicker={setPhotoPicker}
                    FormHandler={FormHandler}
                    extraDataEnabled={extraDataEnabled}
                    extraData={extraData}
                    headersList={headersList}
                />
            )}

            <CopySecretModal
                show={secretModal}
                setShow={setSecretModal}
                secret={secretKey}
                setSecret={setSecretKey}
                setData={setUser}
                generatedPassword={generatedPassword}
                onHide={() => {
                    navigate(routes.contractor.searchEmployee);
                }}
                closeText={'continue'}
            />
        </>
    );
};

export default ContractorCreateEmployee;
